import type { CharacterSave } from '../../game/character';
import { type Cost, freeSlots } from '../../game/inventory';
import { ITEMS } from '../../game/items';

/** How many of a stackable item fit in the bag right now (existing stack room, or a free slot). */
export function roomFor(c: CharacterSave, id: string): number {
  const def = ITEMS[id];
  if (!def) return 0;
  const have = c.inventory.stacks[id] ?? 0;
  if (have === 0 && freeSlots(c) <= 0) return 0;
  return Math.max(0, def.stack - have);
}

/** Multiplies every part of a cost by `n`. */
export function scaleCost(cost: Cost, n: number): Cost {
  const items: Record<string, number> = {};
  for (const [id, v] of Object.entries(cost.items ?? {})) items[id] = v * n;
  return { silver: (cost.silver ?? 0) * n, gold: (cost.gold ?? 0) * n, items };
}

export const fmt = (n: number): string => Math.round(n).toLocaleString('en-US');
